import React from 'react';
import { BadgeCheckIcon, FileXIcon, GiftIcon, RotateCcwIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
const promises = [{
  icon: RotateCcwIcon,
  label: 'Reembolso simple'
}, {
  icon: FileXIcon,
  label: 'Sin formularios'
}, {
  icon: GiftIcon,
  label: 'Te quedás con los bonos'
}];
export function GuaranteeSection() {
  return <section className="border-b border-line bg-cream" data-id="element-102" data-mp="ercxpir1upua">
      <div className="mx-auto max-w-4xl px-5 py-20 text-center lg:py-24" data-id="element-103" data-mp="jrhg5ebipun5">
        <span aria-hidden="true" className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-accent/30 bg-accent-soft text-accent" data-id="element-104" data-mp="ntvv3nc2ga95">
          <BadgeCheckIcon className="h-7 w-7" data-id="element-105" data-mp="xjnviy6ujxlj" />
        </span>

        <div className="mt-6" data-id="element-106" data-mp="xj5or7mk60zd">
          <Eyebrow data-id="element-107" data-mp="12j0dp5mrwghs">Riesgo cero · 7 días protegidos</Eyebrow>
        </div>

        <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-108" data-mp="12gxhu4yxvt55">
          100% de satisfacción o te devolvemos tu dinero
        </h2>

        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-ink-soft" data-id="element-109" data-mp="25sq78zum6b5i">
          Probá El Profe de Guitarra por 7 días. Si tus alumnos no están más comprometidos, o si no ahorrás
          al menos 5 horas de planificación por semana, escribinos. Te devolvemos cada centavo — sin
          preguntas.
        </p>

        <ul className="mx-auto mt-10 flex max-w-2xl flex-col justify-center gap-4 sm:flex-row sm:gap-10" data-id="element-110" data-mp="1ru8lv8s6laqr">
          {promises.map(promise => <li key={promise.label} className="flex items-center justify-center gap-2 text-[11px] font-semibold uppercase tracking-eyebrow text-ink-soft" data-id="element-111" data-mp="2jj24te9yx241">
              <promise.icon aria-hidden="true" className="h-4 w-4 text-accent" data-id="element-112" data-mp="2artduoq8spfl" />
              {promise.label}
            </li>)}
        </ul>
      </div>
    </section>;
}